import React, { useEffect, useState } from 'react'
import { set } from '../store'
import { Users } from 'lucide-react'
import Picker from './Picker'

function mapLabel(jid, fallback) {
  var gs = window.allGroups
  if (Array.isArray(gs)) {
    var match = gs.find(function (g) { return g.jid === jid })
    if (match && match.label) return match.label
  }
  return fallback
}

function mapPlaces(jid) {
  var gs = window.allGroups
  if (Array.isArray(gs)) {
    var match = gs.find(function (g) { return g.jid === jid })
    if (match && match.places) return match.places
  }
  return ''
}

export default function GroupSelect() {
  var [groups, setGroups] = useState([])
  var [selected, setSelected] = useState('')
  var [ready, setReady] = useState(false)
  var [timedOut, setTimedOut] = useState(false)

  useEffect(function () {
    function readFromSelect() {
      var sel = document.getElementById('groupSelect')
      if (!sel || sel.options.length <= 1) return null
      return Array.from(sel.options)
        .filter(function (o) { return o.value && o.value !== '' })
        .map(function (o) { return { jid: o.value, name: mapLabel(o.value, o.textContent || o.value), places: mapPlaces(o.value) } })
    }

    function readFromAllGroups() {
      var gs = window.allGroups
      if (!gs || !Array.isArray(gs) || gs.length === 0) return null
      return gs
        .filter(function (g) { return g && g.jid })
        .reduce(function (acc, g) {
          if (acc.some(function (x) { return x.jid === g.jid })) return acc
          var l = (g.label || g.name || g.jid || '').trim()
          if (l === 'Unknown' || l === '') l = 'Grupo sin nombre'
          if (l.includes('@')) l = l.split('@')[0]
          acc.push({ jid: g.jid, name: mapLabel(g.jid, l), places: g.places || '' })
          return acc
        }, [])
    }

    function readFromAllRides() {
      var rides = window.allRides
      if (!rides || !Array.isArray(rides) || rides.length === 0) return null
      var seen = {}
      rides.forEach(function (r) {
        if (!r || !r.groupJid || seen[r.groupJid]) return
        seen[r.groupJid] = r.groupName || r.groupJid
      })
      return Object.keys(seen).map(function (jid) {
        var n = seen[jid]
        if (n === 'Unknown' || !n) n = jid
        if (n.includes('@')) n = n.split('@')[0]
        return { jid: jid, name: mapLabel(jid, n), places: mapPlaces(jid) }
      })
    }

    var pollCount = 0
    var interval = setInterval(function () {
      pollCount++
      if (pollCount > 50) {
        clearInterval(interval)
        setReady(true)
        setTimedOut(true)
        return
      }
      var opts = readFromSelect() || readFromAllGroups() || readFromAllRides()
      if (opts && opts.length > 0) {
        setGroups(opts)
        setReady(true)
        clearInterval(interval)
        if (window.legacyStore && typeof window.legacyStore.getSelectedGroup === 'function') {
          var cur = window.legacyStore.getSelectedGroup()
          if (cur) setSelected(cur)
        }
      }
    }, 300)

    var storeUnsub = null
    if (window.legacyStore && typeof window.legacyStore.subscribe === 'function') {
      storeUnsub = window.legacyStore.subscribe(function (key, value) {
        if (key === 'selectedGroup') setSelected(value || '')
      })
    }

    return function () {
      clearInterval(interval)
      if (typeof storeUnsub === 'function') storeUnsub()
    }
  }, [])

  function pick(jid) {
    set('selectedGroup', jid)
    setSelected(jid)
    if (window.legacyStore && typeof window.legacyStore.setSelectedGroup === 'function') {
      window.legacyStore.setSelectedGroup(jid)
    }
  }

  if (!ready) {
    return (
      <div className="text-sm text-slate-500">Cargando grupos...</div>
    )
  }

  if (groups.length === 0) {
    return (
      <div className="text-sm text-slate-500">{timedOut ? 'No hay grupos disponibles' : 'Cargando grupos...'}</div>
    )
  }

  return <Picker value={selected} onChange={pick} placeholder="Selecciona un grupo..." icon={Users} options={groups.map(function (group) {
    return { value: group.jid, label: group.name, description: group.places }
  })} />
}
